import * as React from "react";
import {
  AppBar,
  Box,
  Container,
  Fab,
  Icon,
  SvgIcon,
  Toolbar,
  Typography,
  useMediaQuery,
} from "@mui/material";
// import UserAuthModal from "../User/Login/UserAuthModal";
import { FlexEmpty } from "../Utility/FlexEmpty";
import { AccountCircle } from "@mui/icons-material";
import { LinkButton } from "../Utility/LinkButton";
import MobileNav from "./MobileNav";
// import AdminCheck from "../Admin/AdminCheck";
import SelectLanguageMenuButton from "../i18n/SelectLanguageMenuButton";
import TranslateWrapper from "../i18n/TranslateWrapper";
import { HomeIcon } from "../Utility/Icons/HomeIcon";
import { ConsoleIcon } from "../Utility/Icons/ConsoleIcon";
import { Mail } from "@mui/icons-material";
import dynamic from "next/dynamic";
import Link from "next/link";
import NavSupportMenu from "./NavSupportMenu";
import { vercel_env } from "../clientConfig";
import HelpIcon from "@mui/icons-material/Help";
import { ThemeProvider, useTheme } from "@mui/material/styles";
import SignInButton from "./SignInButton";
import { useTranslation } from "react-i18next";
import { useRCThemeContext } from "../Theme/ThemeContext";
import { useUserContext } from "../User/Auth/UserContext";
import Logo from "./1_redcandle-logo.svg";
import { pink } from "@mui/material/colors";
import { RedcandleIcon } from "../Utility/Icons/RedcandleIcon";
import { mainColor } from "../Theme/Theme";
import { RedCandleFull } from "../Utility/Icons/RedCandleFullSvg";
import { useSmDown } from "./useDownSM";
import { NineSolsIcon } from "../Utility/Icons/NinesolsIcon";
const AdminCheck = dynamic(() => import("../Admin/AdminCheck"), {
  ssr: false,
});
const AuthCheckLoading = dynamic(
  () => import("../Utility/Route/AuthCheckLoading"),
  {
    ssr: false,
  }
);
const MyAccountMenu = dynamic(() => import("./MyAccountMenu"), {
  ssr: false,
});
export default function NavBar() {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("sm"));
  const smDown = useSmDown();
  const { appBarColor, showNavButtons } = useRCThemeContext();
  if (matches) {
    return <MobileNav></MobileNav>;
  } else
    return (
      <AppBar
        position={!smDown ? "relative" : "fixed"}
        // elevation={2}
        // style={{ backgroundColor: theme.palette.primary.main, zIndex: 1 }}
        // style={{}}

        style={{ zIndex: 1, height: 84, justifyContent: "center" }}
      >
        {/* <Suspense fallback={null}> */}
        <NavBarContent></NavBarContent>
        {/* </Suspense> */}
      </AppBar>
    );
}

function NavBarContent() {
  const { t } = useTranslation("common");
  return (
    <Container
      style={
        {
          // maxWidth: 1280,
          // marginLeft: "auto",
          // marginRight: "auto",
          // height: "100%",
        }
      }
    >
      <Toolbar>
        {/* {serverConfig.mode === HostingMode.development && "Local模式"}
        {serverConfig.mode === HostingMode.production && "上線模式"} */}
        {/* <React.Suspense fallback={<div></div>}> */}
        {/* <LogoButton></LogoButton> */}
        {/* <LinkButton variant="contained" color="primary" to="/#game">
            遊戲介紹
          </LinkButton>
          <LinkButton variant="contained" color="primary" to="/#trailer">
            遊戲預告
          </LinkButton>
          <LinkButton variant="contained" color="primary" to="/#rules">
            預購須知
          </LinkButton> */}
        {/* <LinkButton variant="contained" color="primary" to="/"> */}

        <Link href="/" aria-label="Home">
          <a
            title="Red Candle Home"
            id="redcandlelogohome"
            style={{ display: "flex", justifyContent: "center" }}
          >
            <Icon
              sx={[
                { color: "text.primary" },
                {
                  "&:hover": {
                    // color: "primary.main",
                    color: mainColor,
                  },
                },
              ]}
              style={{ width: 150, height: 36 }}
            >
              {/* <SvgIcon> */}
              <RedCandleFull></RedCandleFull>
              {/* </SvgIcon> */}
            </Icon>
          </a>
        </Link>

        {vercel_env == "local" && (
          <Typography color="secondary" variant="h1">
            {vercel_env}環境！
          </Typography>
        )}
        {vercel_env == "development" && (
          <Typography color="secondary" variant="h1">
            {vercel_env}環境！
          </Typography>
        )}
        {/* {vercel_env == "preview" && (
          <Typography color="secondary" variant="h1">
            {vercel_env}環境！
          </Typography>
        )} */}
        {/* </LinkButton> */}
        <Box
          sx={{
            width: 52,
            height: 28,
            borderRight: "solid 2px",
            borderColor: "text.secondary",
          }}
        >
          {/* <div
            style={{  borderRight: "solid 1px" }}
          ></div> */}
        </Box>
        <div style={{ width: 32 }}></div>
        <LinkButton href="/" id="HomeButton">
          <HomeIcon
            style={{
              height: 18,
              width: 18,
              paddingBottom: 0,
              paddingRight: 3,
            }}
          ></HomeIcon>
          <span> {t("nav-store-front")} </span>
        </LinkButton>

        <AuthCheckLoading fallback={null}>
          <LinkButton id={"library"} href="/library">
            <ConsoleIcon
              // sx={{ color: pink[500] }}
              style={{
                height: 18,
                width: 18,
                paddingBottom: 0,
                paddingRight: 4,
              }}
            ></ConsoleIcon>

            <span>{t("nav-my-library")}</span>
          </LinkButton>
        </AuthCheckLoading>
        {/* <LinkButton
          // variant="contained"
          id="nine-sols"
          href="/projects/ninesols"
          // startIcon={}
        >
          <NineSolsIcon
            style={{
              height: 18,
              width: 18,
              paddingBottom: 0,
              // paddingRight: 4,
            }}
          ></NineSolsIcon>
          <span>{t("nav-nine-sols")}</span>
        </LinkButton> */}

        {/* <LinkButton color="primary" href="/event/shanhai9000">
            N҈̨̲̩͎̓͐̽͠ï̴̡̛͈͆͊n҉̨̮̪̲͆̑̕ę̶͚̭͌̓̑͝S̶̢̥͉҇͑ő̶̦̉͜͠l҈̨͕̜̯̓̎̕ş̷̫҇̂͒̄
          </LinkButton> */}
        <AuthCheckLoading fallback={null}>
          <AdminCheck fallback={null}>
            <LinkButton href="/admin">{"管理員"}</LinkButton>
            {/* <LinkButton
                  variant="contained"
                  color="primary"
                  to="/admin/genkey"
                >
                  {"test generate key"}
                </LinkButton> */}

            {/* <LinkButton
                  variant="contained"
                  color="primary"
                  to="/admin_refund"
                >
                  查詢訂單
                </LinkButton>
                <LinkButton variant="contained" color="primary" to="/admin">
                  匯出訂單
                </LinkButton>
                <LinkButton variant="contained" color="primary" to="/sales">
                  販售報表
                </LinkButton> */}
          </AdminCheck>
        </AuthCheckLoading>
        <FlexEmpty></FlexEmpty>
        <SelectLanguageMenuButton></SelectLanguageMenuButton>
        <div style={{ width: 24 }}></div>
        <AuthCheckLoading
          fallback={
            <SignInButton>
              <AccountCircle
                style={{ paddingRight: 4, width: 20, height: 20 }}
              />
              <div style={{ width: 2 }}></div>
              {t("nav-login")}
            </SignInButton>
            // <LinkButton color="primary" to="/login/signIn">
            //   <AccountCircle
            //     style={{ paddingRight: 4, width: 20, height: 20 }}
            //   />
            //   <div style={{ width: 2 }}></div>
            //   {t("nav-login")}
            // </LinkButton>
          }
        >
          <TranslateWrapper ns="myaccount">
            <MyAccountMenu></MyAccountMenu>
          </TranslateWrapper>

          {/* <SignOutButton></SignOutButton> */}
        </AuthCheckLoading>
        {/* </React.Suspense> */}
      </Toolbar>
    </Container>
  );
}
